import apiClient from './api';
import API_ENDPOINTS from './endpoints';
export const categoriesService = {
    async getAllCategories() {
        return apiClient.get(API_ENDPOINTS.CATEGORIES.ALL);
    },
    async getCategoryById(id) {
        return apiClient.get(API_ENDPOINTS.CATEGORIES.BY_ID(id));
    },
    async getCategoryArticles(categoryId) {
        // Traer artículos por CATEGORÍA (endpoint correcto)
        return apiClient.get(API_ENDPOINTS.ARTICLES.BY_CATEGORY(categoryId));
    },
    async getSubcategoryArticles(subcategoryId) {
        return apiClient.get(API_ENDPOINTS.SUBCATEGORIES.ARTICLES(subcategoryId));
    },
    async getSpecificArticle(articleId) {
        return apiClient.get(`/api/articles/${articleId}`);
    },
    async getArticlesByParent(parentId) {
        return apiClient.get(API_ENDPOINTS.ARTICLES.BY_PARENT(parentId));
    },
    // Función helper para transformar Category a formato compatible con InterestCard
    transformToInterestCard(category) {
        return {
            id: category.id,
            name: category.name,
            description: category.description,
            image: category.image_url,
            icon: this.getCategoryIcon(category.name),
            color: this.getCategoryColor(category.name),
            subcategories: category.subcategories
        };
    },
    // Mapeo de iconos por categoría
    getCategoryIcon(categoryName) {
        const iconMap = {
            'Cultura': 'fas fa-theater-masks',
            'Naturaleza': 'fas fa-leaf',
            'Aventura': 'fas fa-mountain',
            'Gastronomía': 'fas fa-utensils',
            'Historia': 'fas fa-landmark',
            'Religión y Espiritualidad': 'fas fa-pray',
            'Artesanía y Compras': 'fas fa-shopping-bag',
            'Vida Nocturna y Entretenimiento': 'fas fa-moon'
        };
        return iconMap[categoryName] || 'fas fa-star';
    },
    // Mapeo de colores por categoría
    getCategoryColor(categoryName) {
        const colorMap = {
            'Cultura': '#8B5CF6',
            'Naturaleza': '#10B981',
            'Aventura': '#F59E0B',
            'Gastronomía': '#EF4444',
            'Historia': '#6B7280',
            'Religión y Espiritualidad': '#3B82F6',
            'Artesanía y Compras': '#EC4899',
            'Vida Nocturna y Entretenimiento': '#6366F1'
        };
        return colorMap[categoryName] || '#6B7280';
    },
    // Función helper para generar slug de categoría
    getCategorySlug(categoryName) {
        return categoryName
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') // Remover acentos
            .replace(/[^a-z0-9\s-]/g, '') // Solo letras, números, espacios y guiones
            .replace(/\s+/g, '-') // Reemplazar espacios con guiones
            .replace(/-+/g, '-') // Múltiples guiones por uno solo
            .trim();
    }
};
export default categoriesService;
